import type { BadgeProps, IconName } from '@hotjar/hotsauce';

export enum QuestionTypes {
  SINGLE_OPEN_ENDED_MULTI_LINE = 'single-open-ended-multiple-line',
  SINGLE_OPEN_ENDED_SINGLE_LINE = 'single-open-ended-single-line',
  EMAIL = 'email',
  SINGLE_CLOSE_ENDED = 'single-close-ended',
  MULTIPLE_CLOSE_ENDED = 'multiple-close-ended',
  RATING_SCALE_5 = 'rating-scale-5',
  RATING_SCALE_7 = 'rating-scale-7',
  NET_PROMOTER_SCORE = 'net-promoter-score',
  TITLE_AND_DESCRIPTION = 'title-and-description',
  REACTION = 'reaction',
}

export interface QuestionTypeItem {
  value: QuestionTypes;
  label: string;
  icon: IconName;
  badge?: BadgeProps['kind'];
}

export const QUESTION_TYPES_SELECT_OPTIONS: QuestionTypeItem[] = [
  { value: QuestionTypes.REACTION, label: 'reaction', icon: 'like' },
  {
    value: QuestionTypes.SINGLE_OPEN_ENDED_MULTI_LINE,
    label: 'long-text',
    icon: 'text_field_tall',
  },
  {
    value: QuestionTypes.SINGLE_OPEN_ENDED_SINGLE_LINE,
    label: 'short-text',
    icon: 'text_field_short',
  },
  { value: QuestionTypes.EMAIL, label: 'email', icon: 'email' },
  { value: QuestionTypes.SINGLE_CLOSE_ENDED, label: 'radio', icon: 'radio_button' },
  {
    value: QuestionTypes.MULTIPLE_CLOSE_ENDED,
    label: 'checkbox',
    icon: 'checkbox',
  },
  { value: QuestionTypes.RATING_SCALE_5, label: 'rating-5', icon: 'rating_scale' },
  { value: QuestionTypes.RATING_SCALE_7, label: 'rating-7', icon: 'rating_scale' },
  {
    value: QuestionTypes.NET_PROMOTER_SCORE,
    label: 'nps',
    icon: 'nps',
  },
  { value: QuestionTypes.TITLE_AND_DESCRIPTION, label: 'statement', icon: 'text' },
];

export const QUESTIONS_WITH_TEXT_INPUT = [
  QuestionTypes.SINGLE_OPEN_ENDED_SINGLE_LINE,
  QuestionTypes.SINGLE_OPEN_ENDED_MULTI_LINE,
];
